import doRequest from "./apiRequestor";

const getDefaultReport = (reportId) => ({
    reportId: reportId,
    title: 'Default Report',
    mainContact: 'support@mandg.com',
    Type: 'PowerBI',
    relatedDataProducts: [],
    reportEmbedUrl: `https://app.powerbi.com/reportEmbed?reportId=${reportId}&autoAuth=true&ctid=aa42167d-6f8d-45ce-b655-d245ef97da66&actionBarEnabled=true&reportCopilotInEmbed=true`
});

export const fetchExternalReportDetails = async (idToken, reportId, setReportDetails, setLoading, setErrorMessage) => {
    if (setLoading) setLoading(true);
    
    const response = await doRequest(`/api/ExternalReports?reportId=${reportId}`, idToken);
    
    // Check if response is 204 No Content or successful
    if (!response.isError && response.status !== 204) {
        if (setReportDetails) setReportDetails(response.data);
        if (setLoading) setLoading(false);
        return response.data;
    } else {
        // Return default report if not found
        const defaultReport = getDefaultReport('efd4cca7-d118-49e9-a04e-634bcaea22cf');
        if (setReportDetails) setReportDetails(defaultReport);
        if (setLoading) setLoading(false);
        return defaultReport;
    }
};

export const fetchExternalReportByDataProduct = async (idToken, dataProductName, setReportDetails, setLoading, setErrorMessage) => {
    if (setLoading) setLoading(true);
    
    const response = await doRequest(`/api/ExternalReports?dataProductId=${encodeURIComponent(dataProductName)}`, idToken);
    
    if (!response.isError && response.status !== 204) {
        if (setReportDetails) setReportDetails(response.data);
        if (setLoading) setLoading(false);
        return response.data;
    } else {
        const defaultReport = getDefaultReport('efd4cca7-d118-49e9-a04e-634bcaea22cf');
        if (setReportDetails) setReportDetails(defaultReport);
        if (setLoading) setLoading(false);
        return defaultReport;
    }
};

export const fetchAllExternalReports = async (idToken, setReports, setLoading, setErrorMessage) => {
    if (setLoading) setLoading(true);
    
    const response = await doRequest('/api/ExternalReports', idToken);
    
    if (!response.isError) {
        if (setReports) setReports(response.data);
        if (setLoading) setLoading(false);
        return response.data;
    } else {
        if (setErrorMessage) setErrorMessage(response.data);
        if (setLoading) setLoading(false);
        return null;
    }
};
